"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecommendationsLoader;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _spinner = _interopRequireDefault(require("../../elements/other/spinner"));
var _rerecLoader = require("@site/rerec-loader");
var _recoreSkeletons = require("@site/recore-skeletons");
/* eslint-disable no-console */

"pl-rxnzwdv";
const SkeletonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SkeletonWrapper",
  class: "pl-s1poz087"
});
const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c1rsnuc4"
});
const skeletonMap = {
  'none': () => /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "skeleton-none"
  }),
  'spinner': null,
  'ux-spinner': _spinner.default,
  'recore-marquee': _recoreSkeletons.RecoreMarqueeSkeleton,
  'plan-type': _recoreSkeletons.PlanTypeSkeleton,
  'recore-marquee-multi': _recoreSkeletons.RecoreMarqueeSkeletonMultiLayout,
  'account-tabs-skeleton': _recoreSkeletons.AccountTabsSkeleton,
  'account-tabs-skeleton-no-carousel': () => /*#__PURE__*/_react.default.createElement(_recoreSkeletons.AccountTabsSkeleton, {
    hideCarousel: true
  }),
  'action-marquee': _recoreSkeletons.ActionMarqueeSkeleton,
  'action-marquee-flipped': () => /*#__PURE__*/_react.default.createElement(_recoreSkeletons.ActionMarqueeSkeleton, {
    flip: true
  }),
  'action-marquee-no-carousel': () => /*#__PURE__*/_react.default.createElement(_recoreSkeletons.ActionMarqueeSkeleton, {
    hideCarousel: true
  }),
  'action-marquee-flipped-no-carousel': () => /*#__PURE__*/_react.default.createElement(_recoreSkeletons.ActionMarqueeSkeleton, {
    hideCarousel: true,
    flip: true
  })
};
const getMarket = () => {
  return (0, _patternLibraryUtils.getCookieValue)('market') || 'en-US';
};
function RecommendationsLoader(props) {
  const {
    _name,
    id,
    conditions,
    skeleton = 'spinner',
    skeletonOptions,
    spinnerSize,
    earlyExecute = false,
    hostUri,
    ...recommendationsProps
  } = props || {};
  const SkeletonComponent = skeletonMap[skeleton];
  const market = getMarket();
  function parseConditions(conditionList) {
    const conditionProps = {};
    conditionList.forEach(({
      fact,
      value,
      operator
    }) => {
      if (operator === 'equal') {
        conditionProps[fact] = value;
      }
    });
    return conditionProps;
  }
  const ruleProp = parseConditions(conditions);
  if (!ruleProp.appKey) {
    // Error: appKey required
    const appKeyError = new Error(`An 'appKey' condition rule is required`);
    console.error(appKeyError);
    return false;
  }
  if (!ruleProp.component) {
    // Error: component required
    const componentError = new Error(`A 'component' condition rule is required`);
    console.error(componentError);
    return false;
  }
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    dataCy: "recommendations-loader",
    padding: "none",
    margin: "none",
    verticalMargin: "none",
    verticalPadding: "none",
    _name: _name
  }, _patternLibraryUtils.tracking.create(_name, true, false)), /*#__PURE__*/_react.default.createElement(_rerecLoader.Recommendations, (0, _extends2.default)({
    id: id,
    className: `recommendations-component`,
    appKey: ruleProp.appKey,
    component: ruleProp.component,
    placementKey: ruleProp.placementKey,
    basketId: ruleProp.basketId,
    bucket: ruleProp.bucket,
    isServerDOM: hostUri && earlyExecute,
    hostUri: hostUri,
    onError: err => {
      props.onError?.(err);
    },
    onLoad: () => {
      props.onLoad?.();
    },
    loadingSpinner: SkeletonComponent && /*#__PURE__*/_react.default.createElement(SkeletonWrapper, null, /*#__PURE__*/_react.default.createElement(SkeletonComponent, (0, _extends2.default)({
      size: spinnerSize,
      market: market
    }, skeletonOptions)))
  }, recommendationsProps)));
}
RecommendationsLoader.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string.isRequired,
  templateName: _propTypes.default.string,
  conditions: _propTypes.default.arrayOf(_propTypes.default.shape({
    fact: _propTypes.default.string,
    value: _propTypes.default.string,
    operator: _propTypes.default.string
  })),
  prefetch: _propTypes.default.bool,
  nameSpace: _propTypes.default.string,
  isInModal: _propTypes.default.bool,
  openInModal: _propTypes.default.bool,
  skipExpressCart: _propTypes.default.bool,
  skipLaunchCall: _propTypes.default.bool,
  skeleton: _propTypes.default.oneOf(['none', 'spinner', 'ux-spinner', 'recore-marquee', 'plan-type', 'recore-marquee-multi', 'account-tabs-skeleton', 'account-tabs-skeleton-no-carousel']),
  skeletonOptions: _propTypes.default.oneOfType([_propTypes.default.shape(_spinner.default.propTypes), _propTypes.default.shape(_recoreSkeletons.RecoreMarqueeSkeleton.propTypes), _propTypes.default.shape(_recoreSkeletons.PlanTypeSkeleton.propTypes), _propTypes.default.shape(_recoreSkeletons.RecoreMarqueeSkeletonMultiLayout.propTypes)]),
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  onAuthError: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onAddToCartComplete: _propTypes.default.func,
  onPurchaseComplete: _propTypes.default.func,
  ..._rerecLoader.Recommendations.propTypes
};